import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { flatMap, flatten, valuesIn, reduce, get } from 'lodash';
import Logo from '../../../../common/svgs/Logo';
import prettyPhone from '../../../../lib/prettyPhone';
import prettyDate from '../../../../lib/prettyDate';
import {lookup, getLookupValue} from '../../../../redux/helpers/staticData';
import * as ui from '../../../../redux/actionCreators/sync/ui.js';

@connect((state) => {
  return {
    staticData: state.staticData,
    jobRequest: state.jobRequest,
    primaryContact: flatMap(state.companyContacts).find((contact) => contact.profile.id === state.jobRequest.primaryContactId) || state.jobRequest.contact,
    labels: get(state, 'labels.JobRequestConfirmation', {})
  };
})

export default class JobRequestConfirmation extends Component {
  static propTypes = {
    params: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    labels: PropTypes.object,
    staticData: PropTypes.object,
    jobRequest: PropTypes.object,
    primaryContact: PropTypes.object
  }

  constructor() {
    super();
  }

  componentWillMount() {
    this.props.dispatch(ui.hideSpinner());
  }

  componentWillReceiveProps(nextProps) {

  }

  getState(value) {
    const state = _.find(this.props.staticData.stateList, function(s) { return s.id == value; });
    return _.get(state, 'abbreviation');
  }

  render() {
    const job = this.props.jobRequest;
    const contact = this.props.primaryContact;
    const skills = flatten(valuesIn(this.props.jobRequest.skills));

    let workdays = [];
    if (job.workdays) {
      workdays = reduce(job.workdays, (days, today) => {
        days.push(lookup(this.props.staticData, 'dayAvailableTypes', {id: today}));
        return days;
      }, []);
    }

    return (
      <div className='job-request-confirmation clearfix'>
        <Logo className='logo' />

        <div className='center-container'>
          <div className='info-container section' data-id='Header'>
            <div className='left'>
              <div className='header'>{this.props.labels.title}</div>
              <div className='job-id sub-header'>Job Request #{job.id}</div>
              <div>{contact.company.name}</div>
              <div>{contact.company.address}</div>
              <div>{contact.company.city}, {this.getState(contact.company.state)} {contact.company.zip}</div>
              <div>{contact.company.address2}</div>
            </div>
            <div className='right'>
              <div className='disclaimer'>This Job Request is submitted by Client in accordance with and subject to the Terms & Conditions below.</div>
              <div className='phone sub-header'>Job Request Contact</div>
              <div>{contact.user.firstName} {contact.user.lastName}</div>
              <div>{contact.profile.title}</div>
              <div>{contact.user.email}</div>
              <div>{lookup(this.props.staticData, 'contactPhoneTypes', {id: contact.user.phoneType1})}{prettyPhone(contact.user.phoneNumber1)}</div>
            </div>
          </div>
          <div className='section'>
            <div className='sub-header'>Position Information</div>
            <div className='info-row'>
              <div className='info-field'>{this.props.labels.positionTypeId}</div>
              <div className='info-data'>{lookup(this.props.staticData, 'positionTypes', {id: job.positionTypeId})}</div>
            </div>
            <div className='info-row'>
              <div className='info-field'>{this.props.labels.industryTypeId}</div>
              <div className='info-data'>{lookup(this.props.staticData, 'industryTypesList', {id: job.industryTypeId})}</div>
            </div>
            {job.industryOther
            &&
            <div className='info-row'>
              <div className='info-field'>{this.props.labels.industryOther}</div>
              <div className='info-data'>{job.industryOther}</div>
            </div>
            }
            <div className='info-row'>
              <div className='info-field'>{this.props.labels.segmentTypeId}</div>
              <div className='info-data'> {lookup(this.props.staticData, 'jobRequestSegmentTypes', {id: job.segmentTypeId})}</div>
            </div>
            {job.segmentOther
            &&
            <div className='info-row'>
              <div className='info-field'>{this.props.labels.segmentOther}</div>
              <div className='info-data'>{job.segmentOther}</div>
            </div>
            }
            <div className='info-row'>
              <div className='info-field'>Does the candidate need to be Licensed?</div>
              <div className='info-data'>{job.licenseRequired ? 'Yes' : 'No'}</div>
            </div>
            <div className='info-row'>
              <div className='info-field'>Does the job require use of dual monitors?</div>
              <div className='info-data'>{job.dualMonitorsRequired ? 'Yes' : 'No'}</div>
            </div>
            <div className='info-row'>
              <div className='info-field'>Does the job require client phone contact?</div>
              <div className='info-data'>{job.outsideContactRequired ? 'Yes' : 'No'}</div>
            </div>
            <div className='info-row'>
              <div className='info-field'>Number of persons required for this type of work</div>
              <div className='info-data'>{job.numberOfPeople}</div>
            </div>
          </div>

          <div className='section'>
            <div className='sub-header'>Job Description</div>
            <div className='job-description'>{job.description}</div>
          </div>

          <div className='section skills-section'>
            <div className='info-row header-row'>
              <div className='sub-header info-field'>Skills</div>
              <div className='sub-header info-data'>Importance</div>
            </div>
            {
              skills.map( (skill, index) =>
                <div>
                  {skill.name !== 'None'
                    &&
                    <div className='info-row'>
                      <div className='info-field'>{skill.name}</div>
                      <div className='info-data'>{lookup(this.props.staticData, 'skillOptionTypes', {id: skill.skillOption})}</div>
                    </div>
                  }
                </div>
              )
            }
          </div>

          <div className='section'>
            <div className='sub-header'>Schedule</div>
            {job.jobTypeId
              &&
              <div>This is a <span className='schedule-data'>{'LONG_TERM' === getLookupValue(this.props.staticData, 'jobTypes', {id: job.jobTypeId}).hardcodelink && 'long term'} project</span>.</div>
            }
            {job.dateStarted
              &&
              <div>The expected start date is <span className='schedule-data'>{prettyDate(job.dateStarted)}</span>.</div>
            }
            {job.dateEnded
              &&
              <div>The expected end date is <span className='schedule-data'>{prettyDate(job.dateEnded)}</span>.</div>
            }
            {job.estimatedHoursPerWeek
              &&
              <div>The estimated number of hours per week are <span className='schedule-data'>{job.estimatedHoursPerWeek}</span>.</div>
            }
            {job.timezone
              &&
              <div>The time zone is <span className='schedule-data'>{lookup(this.props.staticData, 'timezoneList', {id: job.timezone})}</span>.</div>
            }
            {job.workdays
              &&
              <div>The working days of the week are <span className='schedule-data'>{workdays.join(', ')}</span>.</div>
            }
            {job.startTime
              &&
              <div>The preferred start time is  <span className='schedule-data'>{lookup(this.props.staticData, 'workHours', {id: job.startTime})}</span>.</div>
            }
            {job.endTime
              &&
              <div>The end time is <span className='schedule-data'>{lookup(this.props.staticData, 'workHours', {id: job.endTime})}</span>.</div>
            }
          </div>

          <div className='section terms-section' dangerouslySetInnerHTML={{__html: get(this.props.labels, 'termsAndConditions')}}>
          </div>

          {job.dateAuthorized
            &&
            <div className='section signature-section'>
              Confirmed by (Signature): {contact.user.firstName} {contact.user.lastName}
              <br />
              <br />
              Date: {prettyDate(job.dateAuthorized)}
            </div>
          }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/JobRequest/Confirmation/index.js